import React from "react";
import { NavLink } from "react-router-dom";

const Banner = () => {
  return (
    <section className="tw-relative tw-overflow-hidden tw-bg-[#F8FCFF] tw-pt-24 tw-pb-28 lg:tw-pt-36 lg:tw-pb-44" id="product-comparison-banner">
      {/* Background glow */}
      <div className="hero-img-glow tw-absolute tw-top-1/4 tw-left-1/2 tw-transform tw-translate-x-[-50%] tw-translate-y-[-50%] tw-w-96 tw-h-96 tw-bg-indigo-400/10 tw-rounded-full tw-blur-3xl tw-pointer-events-none" />

      <div className="tw-max-w-4xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-relative tw-z-10 tw-text-center">
        
        {/* Badge */}
        <div className="tw-inline-flex tw-items-center tw-gap-2 tw-mb-6 tw-px-3.5 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-[#5D44FF]/20 tw-bg-[#5D44FF]/5 tw-text-[#5D44FF] tw-text-xs tw-font-semibold tw-tracking-wide">
          🆚 Smart Comparison
        </div>

        {/* Heading */}
        <h1 className="tw-text-4xl sm:tw-text-5xl lg:tw-text-6xl tw-font-extrabold tw-tracking-tight tw-leading-[1.15] tw-mb-6 tw-text-slate-900">
          Why we are the Smartest Choice for <br /> <span className="tw-text-[#5D44FF]">Sales & Marketing Automation</span>
        </h1>

        {/* Description */}
        <p className="tw-text-base sm:tw-text-lg tw-text-slate-600 tw-leading-relaxed tw-mb-8">
          When it comes to sales and marketing automation, the right tool can be the game-changer your team needs. While other platforms offer fragmented features, BeyondLeadz delivers a powerful, all-in-one solution tailored for modern businesses. From intelligent lead generation to personalized email marketing, our platform doesn’t just keep up with the competition—it outshines it.
        </p>

        {/* CTA Buttons */}
        <div className="tw-flex tw-justify-center tw-flex-wrap tw-gap-4">
          <NavLink
            to="/signup"
            className="hero-btn-shine tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-bg-[#5D44FF] hover:tw-bg-indigo-600 tw-text-white tw-font-bold tw-text-sm tw-rounded-xl tw-shadow-lg tw-shadow-indigo-500/20 tw-transition-all hover:tw-scale-[1.03]"
          >
            Subscribe Now
          </NavLink>
          <NavLink
            to="/contact-us"
            className="tw-inline-flex tw-items-center tw-justify-center tw-px-8 tw-py-3.5 tw-border tw-border-solid tw-border-slate-200 hover:tw-border-slate-300 tw-text-slate-700 tw-bg-white hover:tw-bg-slate-50 tw-font-bold tw-text-sm tw-rounded-xl tw-transition-all hover:tw-scale-[1.03]"
          >
            Contact us
          </NavLink>
        </div>

      </div>

      {/* Bottom wave divider */}
      <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-overflow-hidden tw-leading-none">
        <svg className="tw-relative tw-block tw-w-full tw-h-12" viewBox="0 0 1440 320" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,320L48,293.3C96,267,192,213,288,192C384,171,480,181,576,202.7C672,224,768,256,864,224C960,192,1056,96,1152,85.3C1248,75,1344,149,1392,186.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="#ffffff" />
        </svg>
      </div>
    </section>
  );
};

export default Banner;
